import React, { useRef } from "react";
import DropDownUploadImg from "../../Theme/Icons/DropDownUploadImg";

import { link } from "../../../utils/Api/url";
import Regenerate from "../../Theme/Icons/Regenerate";
import UploadImageArrowRight from "../../Theme/Icons/UploadImageArrowRight";
import UploadImageArrowLeft from "../../Theme/Icons/UploadImageArrowLeft";
import InfoUploadImage from "../../Theme/Icons/InfoUploadImage";
import useUpload from "../../../utils/customHooks/use-upload";

export default function UploadImageMob({ photo }) {
  const filePiker = useRef(null);
	const {handleUpload} = useUpload()

  const page = "1/1";

  const handleChange = (e) => {
    handleUpload(e.target.files);
  };
  const handleSelect = () => {
    filePiker.current.click();
  };

  return (
    <div className="bg-[#EEECEA]">
      <div class="flex justify-between px-[5%] pt-[26px]">
        <div>
          <div className="border rounded-lg border-gray-300 bg-white flex w-120 p-2 items-center gap-4">
            <select className="flex-grow outline-none appearance-none bg-transparent text-[12px] font-textSec">
              <option value="option1" class="text-[12px] font-textSec">
                1st Picture
              </option>
              <option value="option2" class="text-[12px] font-textSec">
                2 Picture
              </option>
              <option value="option3" class="text-[12px] font-textSec">
                3 Picture
              </option>
            </select>
            <DropDownUploadImg />
          </div>
        </div>
        <div>
          <input
            ref={filePiker}
            type="file"
            multiple
            name="photos"
            class="overflow-hidden w-0 h-0 opacity-0 absolute"
            onChange={handleChange}
            accept="image/*, .png, .jpg, .gif, .web,"
          />
          <button
            class="btn-second px-[16px] py-[7px] text-[12px] text-[#EBB268] border-[1px] font-textBtn"
            onClick={handleSelect}
          >
            Upload New Image
          </button>
        </div>
      </div>
      <div class="flex flex-col items-center justify-center pt-[31px]">
        <div>
          <img
            src={`${link}${photo}`}
            alt="Uploaded Image"
            class="w-[235px] h-[329px] rounded-[8px] shadow-md"
          />
        </div>
      </div>
      <div class="flex justify-center gap-[12px] pt-[30px]">
        <button class="btn px-[16px] py-[8px] text-[12px]  font-textBtn">
          Download All
        </button>
        <button class="btn-second px-[16px] py-[7px] text-[12px] text-[#EBB268] border-[1px] font-textBtn">
          <Regenerate />
          Regenerate All
        </button>
      </div>
      <div class="flex items-center absolute right-[20%]">
        <div className="pt-[5px]">
          <InfoUploadImage />
        </div>
        <p className="text-[#A4A4A4] text-[8px] font-textBtn pt-[7px]">
          Regenerated up to<span className="text-[#433E3E] px-[3px]">3</span>
          times
        </p>
      </div>
      <div class="flex justify-between px-[10%] pt-[47px] pb-[18px]">
        <div class="flex items-center">
          <p class="text-[#433E3E] text-[12px] font-textSec pr-[35px]">
            15 Stickers for you
          </p>
        </div>
        <div class="flex items-center gap-[19px]">
          <div class="cursor-pointer">
            <UploadImageArrowLeft />
          </div>
          <span class="text-[#433E3E] text-[12px]">{page}</span>
          <div class="cursor-pointer">
            <UploadImageArrowRight />
          </div>
        </div>
      </div>
      <div>
        <h2>HERE IS CONTENT FROM API</h2>
      </div>
    </div>
  );
}
